<template>
  <div class="fe-feat-sm mb-20">
    <div class="row g-0 align-items-center">
      <div class="col-5">
        <div class="fe-feat-sm__thumb">
          <router-link :to="`/product-details/${product.product_id}`" class="fe-feat-sm__img-link">
            <img :src="product.image" :alt="product.title" class="fe-feat-sm__img" />
          </router-link>
          <span v-if="product.special_discount_percentage > 0" class="fe-feat-sm__badge">
            -{{ product.special_discount_percentage }}%
          </span>
        </div>
      </div>
      <div class="col-7">
        <div class="fe-feat-sm__body">
          <h6 class="fe-feat-sm__title">
            <router-link :to="`/product-details/${product.product_id}`">{{ product.title }}</router-link>
          </h6>

          <div class="fe-feat-sm__price-block">
            <span class="fe-feat-sm__price">Rs. {{ formatPrice(product.price) }}</span>
            <div v-if="product.special_discount_percentage > 0" class="fe-feat-sm__discount-line">
              <del class="fe-feat-sm__was">Rs. {{ formatPrice(calculateOriginalPrice(product.price, product.special_discount_percentage)) }}</del>
              <span class="fe-feat-sm__off">{{ product.special_discount_percentage }}% Off</span>
            </div>
          </div>

          <router-link :to="`/product-details/${product.product_id}`" class="fe-feat-sm__cta">
            View More <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCurrency } from "@/composables/useCurrency"
import { calculateOriginalPrice } from "@/utils/utils"

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { formatPrice } = useCurrency()
    return { formatPrice, calculateOriginalPrice }
  },
};
</script>

<style scoped>
.fe-feat-sm {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 14px;
  overflow: hidden;
  height: calc(100% - 20px);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.fe-feat-sm:hover {
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.fe-feat-sm__thumb {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  min-height: 140px;
}

.fe-feat-sm__img-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fe-feat-sm__img {
  max-width: 110px;
  max-height: 130px;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}
.fe-feat-sm:hover .fe-feat-sm__img {
  transform: scale(1.05);
}

.fe-feat-sm__badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #16a34a;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 5px;
}

.fe-feat-sm__body {
  padding: 12px 14px 14px 4px;
}

.fe-feat-sm__title {
  margin: 0 0 8px;
}
.fe-feat-sm__title a {
  color: #1a1a1a !important;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.3;
  text-transform: uppercase;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.fe-feat-sm__title a:hover {
  color: var(--fe-accent, #fcbe00) !important;
}

.fe-feat-sm__price-block {
  margin-bottom: 10px;
}

.fe-feat-sm__price {
  font-size: 16px;
  font-weight: 800;
  color: #e65100;
  line-height: 1.2;
}

.fe-feat-sm__discount-line {
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.fe-feat-sm__was {
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
}

.fe-feat-sm__off {
  font-size: 11px;
  font-weight: 700;
  color: #e65100;
}

.fe-feat-sm__cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(145deg, var(--fe-accent, #fcbe00) 0%, var(--fe-accent-hover, #e5ac00) 100%);
  color: #fff !important;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 7px 16px;
  border-radius: 999px;
  text-decoration: none;
  transition: filter 0.2s, transform 0.2s;
  box-shadow: 0 3px 10px rgba(252, 190, 0, 0.25);
}
.fe-feat-sm__cta:hover {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

@media (max-width: 575px) {
  .fe-feat-sm__thumb {
    min-height: 110px;
    padding: 10px;
  }
  .fe-feat-sm__img {
    max-width: 80px;
    max-height: 100px;
  }
  .fe-feat-sm__body {
    padding: 10px 12px 12px 2px;
  }
  .fe-feat-sm__price {
    font-size: 14px;
  }
}
</style>
